import Long from "long";
import _m0 from "protobufjs/minimal";
export const protobufPackage = "snapchat.cdp.cof";
export interface LensesSignals {
    lastLensActivatedTime: string;
    lastSnappableLensActivatedTime: string;
    isAnyEffectApplied: boolean;
}
function createBaseLensesSignals(): LensesSignals {
    return { lastLensActivatedTime: "0", lastSnappableLensActivatedTime: "0", isAnyEffectApplied: false };
}
export const LensesSignals = {
    encode(message: LensesSignals, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.lastLensActivatedTime !== "0") {
            writer.uint32(8).uint64(message.lastLensActivatedTime);
        }
        if (message.lastSnappableLensActivatedTime !== "0") {
            writer.uint32(16).uint64(message.lastSnappableLensActivatedTime);
        }
        if (message.isAnyEffectApplied === true) {
            writer.uint32(24).bool(message.isAnyEffectApplied);
        }
        return writer;
    },
    decode(input: _m0.Reader | Uint8Array, length?: number): LensesSignals {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensesSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lastLensActivatedTime = longToString(reader.uint64() as Long);
                    break;
                case 2:
                    message.lastSnappableLensActivatedTime = longToString(reader.uint64() as Long);
                    break;
                case 3:
                    message.isAnyEffectApplied = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial<I extends Exact<DeepPartial<LensesSignals>, I>>(object: I): LensesSignals {
        const message = createBaseLensesSignals();
        message.lastLensActivatedTime = object.lastLensActivatedTime ?? "0";
        message.lastSnappableLensActivatedTime = object.lastSnappableLensActivatedTime ?? "0";
        message.isAnyEffectApplied = object.isAnyEffectApplied ?? false;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;
function longToString(long: Long) {
    return long.toString();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
